import RssFeedIcon from '@mui/icons-material/RssFeed';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

export const fisicCardActions = [
    {
        Icon: LockOutlinedIcon,
        label: "Bloquear"
    },
    {
        Icon: KeyOutlinedIcon,
        label: "Senha"
    },
    {
        Icon: RssFeedIcon,
        label: "Aproximação"
    },
    {
        Icon: AddCardOutlinedIcon,
        label: "2° Via"
    }
]
export const virtualCardActions = [
    {
        Icon: LockOutlinedIcon,
        label: "Bloquear"
    },
    {
        Icon: DeleteOutlineOutlinedIcon,
        label: "Excluir"
    }
]